var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "google-chat",
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.575,
    height: 54.836,
    viewBox: "0 0 52.575 54.836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M24.373,131.013V113.19H16.586a4.152,4.152,0,0,0-4.146,4.157v36.842a2.075,2.075,0,0,0,3.543,1.47l8.566-8.566H48.941a4.142,4.142,0,0,0,4.146-4.146V135.16H28.53a4.152,4.152,0,0,1-4.157-4.147Z",
    transform: "translate(-12.44 -101.434)",
    fill: "#00ac47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M157.825,6h-32.34a4.142,4.142,0,0,0-4.146,4.146v7.612H145.9a4.143,4.143,0,0,1,4.141,4.146V39.715h7.787a4.142,4.142,0,0,0,4.146-4.146V10.145A4.143,4.143,0,0,0,157.825,6Z",
    transform: "translate(-109.396 -6)",
    fill: "#5bb974"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M145.808,113.19H121.24V131a4.143,4.143,0,0,0,4.146,4.146h24.557v-17.8a4.136,4.136,0,0,0-4.135-4.157Z",
    transform: "translate(-109.307 -101.434)",
    fill: "#00832d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.c3f6fbd0f7375e896bcc798521b1c04d.svg";
export { ForwardRef as ReactComponent };